import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {AsideItem, AsideSection} from '../../shared/models/aside/interfaces';

export type AsidePosition = 'hidden' | 'fixed' | 'shown';

const LOCAL_STORAGE_KEY = 'asidePosition';


@Injectable({
  providedIn: 'root',
})
export class AsideService {
  private globalSections: AsideSection[] = [];
  private globalSections$: BehaviorSubject<AsideSection[]> = new BehaviorSubject<AsideSection[]>([]);

  private contextSections: AsideSection[] = [];
  private contextSections$: BehaviorSubject<AsideSection[]> = new BehaviorSubject<AsideSection[]>([]);

  asidePosition$: BehaviorSubject<AsidePosition>;

  private controlsEnabled: boolean = false;


  constructor() {
    let current: AsidePosition = localStorage.getItem(LOCAL_STORAGE_KEY) as AsidePosition;

    if (!current) {
      current = 'fixed';
    }

    this.asidePosition$ = new BehaviorSubject<AsidePosition>(current);

    this.populateGlobalSections();
  }


  toggleFixed() {
    if (this.asidePosition$.value === 'fixed') {
      localStorage.setItem(LOCAL_STORAGE_KEY, 'hidden');
      this.asidePosition$.next('hidden');
    } else {
      localStorage.setItem(LOCAL_STORAGE_KEY, 'fixed');
      this.asidePosition$.next('fixed');
    }
  }


  /**
   * Not all users will have the "Controls" item enabled by default.
   */
  enableControls() {
    this.controlsEnabled = true;
    this.populateGlobalSections();
  }


  getGlobalSections$(): BehaviorSubject<AsideSection[]> {
    return this.globalSections$;
  }


  getContextSections$(): BehaviorSubject<AsideSection[]> {
    return this.contextSections$;
  }


  replaceContextSections(sections: AsideSection[]) {
    this.contextSections = this.prepareSections(sections);
    this.contextSections$.next(this.contextSections);
  }


  private prepareSections(sections: AsideSection[]): AsideSection[] {
    for (let section of sections) {
      for (let item of section.items) {
        if (typeof item.subitems === 'undefined') {
          item.subitems = [];
        }

        if (typeof item.expanded === 'undefined') {
          item.expanded = false;
        }
      }
    }

    return sections;
  }


  private populateGlobalSections() {
    const items: AsideItem[] = [
      {
        text: 'Apps',
        path: '/apps',
      },
      {
        text: 'Invites',
        path: '/invitations',
      },
      // {
      //   text: 'Sharing',
      //   path: '/sharing',
      // },
    ];

    if (this.controlsEnabled) {
      items.push({
        text: 'Controls',
        path: '/controls',
        iconItems: [
          {
            icon: 'square-h',
            path: '/controls/hubs',
          },
          {
            icon: 'square-d',
            path: '/controls/devices',
          },
          {
            icon: 'square-t',
            path: '/controls/tiles',
          },
        ],
      });
    }

    this.globalSections = this.prepareSections([{
      name: 'Platform',
      items: items,
    }]);

    this.globalSections$.next(this.globalSections);
  }
}
